//CONSTANTS
import {
  GET_ALL_CUSTOM_SKELETONS_SUCCESS,
  GET_CUSTOM_SKELETON_BY_ID_SUCCESS,
  GET_SKELETON_DEFAULT_FIELDS_SUCCESS,
  RESET_ACTUAL_CUSTOM_SKELETON,
} from "./constants"

const initialState = {
  customSkeletons: [],
  defaultFields: {},
  actualCustomSkeleton: {},
}

function customSkeletonsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_CUSTOM_SKELETONS_SUCCESS:
      return {
        ...state,
        customSkeletons: payload,
      }
    case GET_SKELETON_DEFAULT_FIELDS_SUCCESS:
      return {
        ...state,
        defaultFields: payload,
      }
    case GET_CUSTOM_SKELETON_BY_ID_SUCCESS:
      return {
        ...state,
        actualCustomSkeleton: payload,
      }
    case RESET_ACTUAL_CUSTOM_SKELETON:
      return {
        ...state,
        actualCustomSkeleton: initialState.actualCustomSkeleton,
      }
    default:
      return state
  }
}

export default customSkeletonsReducer
